var React = require('react');

function Progress (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"-0.13","y":"8.5","width":"17.78","height":"2","transform":"translate(-4.15 8.98) rotate(-45)","key":0}),React.createElement("polygon",{"points":"16.05 14.57 14.05 14.57 14.05 4.21 4.03 4.21 4.03 2.21 16.05 2.21 16.05 14.57","key":1})]);
}

Progress.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Progress;

Progress.default = Progress;
